module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338628/point01-44ec7f1b54e92584f67385134b78c5f4.png";